export default {
    _default: (field) => `Le champ n'est pas valide.`,
    _invalid_format: (field, {format}) => `The field must be in the format ${format}.`,
    _atLeastOneRule: (field) => ` TODO `,
    equals: (field) => `Le champ TODO .`,
    after: (field, {target, inclusion, format}) => `Le champ doit être postérieur à ${target}.`,
    alphadash: (field) => `Le champ ne peut contenir que des caractères alpha-numériques, tirets ou soulignés.`,
    alphanumeric: (field) => `Le champ ne peut contenir que des caractères alpha-numériques.`,
    alphaspaces: (field) => `Le champ ne peut contenir que des lettres ou des espaces.`,
    alpha: (field) => `Le champ ne peut contenir que des lettres.`,
    before: (field, {target, inclusion, format}) => `Le champ doit être antérieur à ${target}.`,
    between: (field, {form, to}) => `Le champ doit être compris entre ${form} et ${to}.`,
    dateBetween: (field, {min, max}) => `Le champ doit être situé entre ${min} et ${max}.`,
    date: (field, {format}) => `Le champ doit être au format ${format}.`,
    time: (field) => `Le champ doit être au format HH:mm:ss.`,
    datetime: (field, {format}) => `Le champ doit être au format ${format}.`,
    decimal: (field, {decimals = '*'} = {}) => `Le champ doit être un nombre et peut contenir ${decimals === '*' ? '' : decimals} décimales.`,
    digits: (field, {length}) => `Le champ doit être un nombre entier de ${length} chiffres.`,
    integer: (field) => `The TODO .`,
    email: (field) => `Le champ doit être une adresse e-mail valide.`,
    in: (field) => `Le champ doit être une valeur valide.`,
    ip: (field) => `Le champ doit être une adresse IP.`,
    maxlength: (field, {length}) => `Le champ ne peut pas contenir plus de ${length} caractères.`,
    max: (field, {max}) => `Le champ doit avoir une valeur de ${max} ou moins.`,
    minlength: (field, {length}) => `Le champ doit contenir au minimum ${length} caractères.`,
    min: (field, {min}) => `Le champ doit avoir une valeur de ${min} ou plus.`,
    numeric: (field) => `Le champ ne peut contenir que des chiffres.`,
    match: (field) => `Le champ est invalide.`,
    required: (field) => `Le champ est obligatoire.`,
    url: (field) => `Le champ n'est pas une URL valide.`
};
